export default __webpack_public_path__ + "static/media/shopping.d19b320e.svg";